<template>
  <div class="header-box-item" :class="{'is-center': center, 'is-right': right}">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'HeaderBoxItem',
    props: {
      center: {
        type: Boolean
      },
      right: {
        type: Boolean
      }
    }
  }
</script>
